import { IDisclaimers } from '@lib/types/dist/IDisclaimers';
import { Typography } from '@ace-clublabs/shared-component-library';
import { JSX } from 'react';
import Box from '@mui/material/Box';
import { disclaimerStyles } from '../assets/market-content/utils/disclaimerStyles';
import { CurrentPayPlan } from '@ace-clublabs/common-membership-api-types';
import { MembershipTerm } from '../containers/BenefitsPage';

export interface DisclaimerProps {
  disclaimers?: IDisclaimers | null;
  payTerm: MembershipTerm;
  allowedBillPlans: CurrentPayPlan[];
}

export const DisclaimerDisplay: (props: DisclaimerProps) => JSX.Element = ({
  disclaimers,
  payTerm,
  allowedBillPlans,
}) => {
  //when autopay is not required, filter out the autopay section, may need to refactor for more robust solution
  const isAutoPayRequired = payTerm === 'monthly' || !allowedBillPlans.includes(CurrentPayPlan.ONETIME);

  const DisclaimerMessages = disclaimers?.sections
    ?.filter((section) => {
      const isAutoPayDisclaimer =
        section.value.toLowerCase().includes('auto pay') || section.value.toLowerCase().includes('autopay');

      if (isAutoPayDisclaimer && !isAutoPayRequired) {
        return false;
      }
      return true;
    })
    .map((section, index) => {
      const { value, isBold } = section;
      return (
        <div key={index}>
          <Typography
            variant="b3Regular"
            sx={isBold ? disclaimerStyles.boldParagraph : disclaimerStyles.standardParagraph}
          >
            <span dangerouslySetInnerHTML={{ __html: value }} />
          </Typography>
        </div>
      );
    });

  return <Box sx={disclaimerStyles.containerStyle}>{DisclaimerMessages ?? ''}</Box>;
};
